/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";

export default class CamujalService extends MainService {
  static listAllPaginationtoSend(params) {
    return this.postSEC(ServiceConstant.CAMUJAL_LISTALL_PAGINATION_TOSEND, params);
  }
  static listAllPaginationSent(params) {
    return this.postSEC(ServiceConstant.CAMUJAL_LISTALL_PAGINATION_SENT, params);
  }
  static getHistorySend(params) {
    return this.postSEC(ServiceConstant.CAMUJAL_HISTORYSEND, params);
  }
  
  static sendStudy(params) {
    return this.postSEC(ServiceConstant.CAMUJAL_SENDSTUDY, params);
  }

  static sendStudyDiscarted(params) {
    return this.postSEC(ServiceConstant.CAMUJAL_SENDSTUDY_DISCARTED, params);
  }

}
